(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || error.message || 'Kurven kunne ikke opdateres.');
        });
      }
      return response.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Kurven kunne ikke hentes.');
      return response.json();
    });
  }

  function rebuildCart(cart) {
    var detail = { cart: cart };
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:build', { detail: detail }));
  }

  function setDrawerBusy(drawer, busy) {
    drawer.classList.toggle('is-updating', busy);
    drawer.querySelectorAll('[data-hl-cart-quantity], [data-hl-cart-remove], [data-hl-cart-add]').forEach(function (button) {
      if (!busy && button.hasAttribute('data-hl-cart-max')) return;
      button.disabled = busy;
    });
  }

  function syncFooter(drawer) {
    var items = drawer.querySelector('.hl-cart-items');
    var originalTotal = drawer.querySelector('[data-hl-cart-original-total]');
    if (!items || !originalTotal) return;

    var originalCents = parseInt(items.dataset.originalTotal || '0', 10);
    var subtotalCents = parseInt(items.dataset.cartSubtotal || '0', 10);
    originalTotal.textContent = formatMoney(originalCents);
    originalTotal.classList.toggle('hide', originalCents <= subtotalCents);
  }

  function init() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.hlCartReady === 'true') return;
    drawer.dataset.hlCartReady = 'true';
    var mutationPending = false;
    var awaitingRebuild = false;
    var expectedItemCount = null;

    function finishMutation() {
      mutationPending = false;
      awaitingRebuild = false;
      expectedItemCount = null;
      setDrawerBusy(drawer, false);
    }

    function mutateCart(url, body) {
      if (mutationPending) return;

      mutationPending = true;
      awaitingRebuild = false;
      setDrawerBusy(drawer, true);

      request(url, body).then(function (cart) {
        if (cart && cart.item_count != null) return cart;
        return getCart();
      }).then(function (cart) {
        expectedItemCount = Number(cart.item_count);
        awaitingRebuild = true;
        rebuildCart(cart);
      }).catch(function (error) {
        window.alert(error.message);
        finishMutation();
      });
    }

    drawer.addEventListener('click', function (event) {
      var quantityButton = event.target.closest('[data-hl-cart-quantity]');
      var removeButton = event.target.closest('[data-hl-cart-remove]');
      var addButton = event.target.closest('[data-hl-cart-add]');

      if (quantityButton || removeButton) {
        event.preventDefault();
        var changeButton = removeButton || quantityButton;
        var key = changeButton.dataset.hlCartKey;
        var line = parseInt(changeButton.dataset.hlCartLine || '0', 10);
        var quantity = removeButton ? 0 : Math.max(0, parseInt(changeButton.dataset.hlCartQuantity || '0', 10));
        var maxQuantity = parseInt(changeButton.dataset.hlCartMax || '0', 10);
        if (!removeButton && maxQuantity > 0 && quantity > maxQuantity) return;
        var body = { quantity: quantity };

        if (key) {
          body.id = key;
        } else if (line > 0) {
          body.line = line;
        } else {
          console.warn('[hl-cart-drawer] Missing cart line identifier.');
          return;
        }

        mutateCart((window.theme && theme.routes && theme.routes.cartChange) || '/cart/change.js', body);
        return;
      }

      if (addButton) {
        event.preventDefault();
        var variantId = parseInt(addButton.dataset.hlCartAdd, 10);
        mutateCart((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
          items: [{ id: variantId, quantity: 1 }]
        });
      }
    });

    var products = drawer.querySelector('[data-products]');
    if (products) {
      new MutationObserver(function () {
        syncFooter(drawer);
        if (awaitingRebuild) {
          setDrawerBusy(drawer, true);
          var currentItems = drawer.querySelector('.hl-cart-items');
          var currentItemCount = currentItems ? Number(currentItems.dataset.count) : null;
          if (currentItemCount === expectedItemCount) finishMutation();
        }
      }).observe(products, { childList: true });
    }

    syncFooter(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
